import { CalendarClock, CalendarCheck, History } from "lucide-react";

const tabs = [
  { id: "requests", label: "Requests", icon: CalendarClock },
  { id: "upcoming", label: "Upcoming", icon: CalendarCheck },
  { id: "history", label: "Order History", icon: History },
];

export default function BookingTabs({ activeTab, setActiveTab, counts }) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {tabs.map(({ id, label, icon: Icon }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setActiveTab(id)}
            className={`flex items-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-lg border transition ${
              isActive
                ? "bg-indigo-600 border-indigo-600 text-white"
                : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
            <span
              className={`text-xs font-bold px-1.5 py-0.5 rounded-full ${
                isActive ? "bg-white/20" : "bg-gray-100 text-gray-500"
              }`}
            >
              {counts[id]}
            </span>
          </button>
        );
      })}
    </div>
  );
}